import { useMutation } from "@tanstack/react-query";
import { mutations } from "@core-shop/cache";

export function useOnLikeNews() {
  const { mutationFn } = mutations.onLikeNews();
  return useMutation({
    mutationFn,
  });
}
